<template>
  <responsive-modal v-model="visible" title="Integrar Hotzapp">
    <div class="tool-modal-hotzapp">
      <a
        href="https://www.hotzapp.com/"
        target="_blank"
        class="integration-link"
      >
        Conheça a Hotzapp
        <i class="ph ph-arrow-square-out" />
      </a>
      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <snow-select
          :disabled="form.id != null"
          id="product-select"
          label="Produto"
          v-model="form.product_id"
          :errors="errors.product_id"
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </action-dispatcher>
      <snow-input
        label="Descrição da integração"
        id="description"
        v-model="form.description"
      />
      <action-dispatcher action="integration/getTypeEvents">
        <snow-checkboxes-dropdown
          label="Eventos disparados"
          id="events-select"
          v-model="form.events"
          :options="normalizedTypeEvents"
        />
      </action-dispatcher>
      <snow-input label="URL" id="url" v-model="form.url" :rules="rules.url" />
      <div class="snow-submit-buttons">
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="
            visible = false;
            clear();
          "
        />
        <snow-button
          size="lg"
          text="Salvar"
          :disabled="!isValid"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
import { required, validUrl } from "@/functions/validation";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["description", "status", "events", "url", "product_id"], {
        events: []
      }),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
        this.form.events = v.events.map(e => e.event);
      }
    }
  },
  computed: {
    ...mapState("integration", ["typeEvents"]),
    ...mapState("product", ["products"]),
    isValid() {
      return this.form.events.length && this.form.product_id && this.form.url;
    },
    normalizedTypeEvents() {
      return this.typeEvents.map(e => ({
        id: e.id,
        label: e.name
      }));
    },
    rules() {
      return {
        url: [required(), validUrl()]
      };
    }
  },
  methods: {
    clear() {
      this.form = { events: [] };
      this.$emit("clear-edit");
    },
    onSubmit() {
      this.loading = false;
      this.visible = false;
      this.$emit("loading");
      setTimeout(() => {
        this.$emit("update-list");
      }, 5200);
      this.clear();
    },
    submit() {
      if (this.loading) return;

      this.loading = true;

      this.form.events = this.form.events.map(e => {
        return { event: e };
      });
      const data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$message.success("A integração foi salva!");
          this.onSubmit();
        })
        .catch(e =>
          this.handleErrors(
            e,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar integração"
          )
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-hotzapp {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
